import React, { createContext, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api'; // Import our new API service

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    
    // Initialize state from localStorage to stay logged in across page reloads
    const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('user')) || null);
    const [token, setToken] = useState(() => localStorage.getItem('authToken') || null);

    const login = async (identifier, password) => {
        // This function will be called from the LoginPage
        const response = await api.post('/auth/login', { identifier, password });
        
        const { token: apiToken, user: apiUser } = response.data;

        // Update state and save to localStorage
        localStorage.setItem('authToken', apiToken);
        localStorage.setItem('user', JSON.stringify(apiUser));
        setToken(apiToken);
        setUser(apiUser);
        
        // Navigate to the chat page after successful login
        // We are simplifying the navigation logic from your example for this app.
        navigate('/');
    };

    const logout = () => {
        // Clear state and localStorage
        setUser(null);
        setToken(null);
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        
        // Redirect to login page
        navigate('/login');
    };

    const value = useMemo(() => ({
        user,
        token,
        login,
        logout,
        isAuthenticated: !!token,
    }), [user, token]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};